import { DeploymentEnvironments } from '@missionlabs/types'
import { getFacebookEnvironment } from '@missionlabs/utils'

export const initFacebookSDK = (environment?: DeploymentEnvironments) => {
    return new Promise<void>(resolve => {
        const { appID } = getFacebookEnvironment(environment)

        if (window.FB) {
            window.FB.init({
                appId: appID,
                xfbml: true,
                version: 'v22.0'
            })

            resolve()
            return
        }

        window.fbAsyncInit = () => {
            window.FB.init({
                appId: appID,
                xfbml: true,
                version: 'v22.0'
            })

            resolve()
        }
        ;(function (d, s, id) {
            const fjs = d.getElementsByTagName(s)[0]
            if (d.getElementById(id)) return

            const js = d.createElement(s) as HTMLScriptElement
            js.id = id
            js.src = 'https://connect.facebook.net/en_US/sdk.js'
            fjs.parentNode?.insertBefore(js, fjs)
        })(document, 'script', 'facebook-jssdk')
    })
}
